// extracted by mini-css-extract-plugin
module.exports = {"appBoard":"App_appBoard__2pP0m","chButtonWrapper":"App_chButtonWrapper__2H1X4","checkButtonWrapper":"App_checkButtonWrapper__1mcfv","cardBoard":"App_cardBoard__1zqhh"};